// extracted by mini-css-extract-plugin
export default {"indicators":"StepIndicator_indicators__HdyQQ","dot":"StepIndicator_dot__16+Lp","activeDot":"StepIndicator_activeDot__ZU1DJ","completedDot":"StepIndicator_completedDot__eHfN3"};